<template>
  <el-dialog v-if="dialogVisible" width="800px" :title="title" :visible.sync="dialogVisible" :before-close="dialogClose">
    <BjPage
      ref="BjPage"
      height="500px"
      :col-span="colSpan"
      :get-action="queryApi"
      :query-params="queryParams"
      :serial="serial"
      :selection="selection"
      @handleSelectionChange="handleSelectionChange"
    >
      <template v-slot:baseForm>
        <slot name="baseForm" />
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            align="center"
          >
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop == 'staffDepartment'">
                <span>{{ $t(staffDeptList.bjGet(scope.row[col.prop])) }}</span>
              </template>
              <template v-else-if="col.prop == 'staffRole'">
                <span>{{ $t(staffRoleList.bjGet(scope.row[col.prop])) }}</span>
              </template>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogClose">{{ $t('cancelText') }}</el-button>
      <el-button type="primary" @click="dialogConfirm">{{ $t('okText') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
export default {
  name: 'BjLogTableDialog',
  mixins: [pageMiXin],
  props: {
    title: {
      type: String,
      default: '',
    },
    columns: {
      type: Array,
      default: () => {
        return [];
      },
    },
    queryParams: {
      type: Object,
      default: () => {
        return {};
      },
    },
    cSpan: {
      type: Number,
      default: 6,
    },
    queryApi: {
      type: Function,
      default: null,
    },
    // 部门下拉列表 
    staffDeptList: {
      type: Array,
      default: () => [],
    },
    staffRoleList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      colSpan: 6,
      serial: false,
      selection: true,
      dialogVisible: false,
      labelList: [
        { label: this.$t('AccountManagement.staff.name'), prop: 'staffName', isCheck: true, disabled: false },
        { label: this.$t('AccountManagement.staff.department'), prop: 'staffDepartment', isCheck: true, disabled: false },
        { label: this.$t('AccountManagement.staff.role'), prop: 'staffRole', isCheck: true, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width:160 },
      ],
    };
  },
  watch: {
    cSpan(v) {
      this.colSpan = v;
    },
  },
  methods: {
    show() {
      this.dialogVisible = true;
    },
    dialogClose() {
      this.dialogVisible = false;
    },
    dialogConfirm() {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning'));
        return;
      }
      this.$emit('onConfirm', this.selectedRows);
      this.dialogVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
  ::v-deep .bj-page .el-form-item__label{
    display: none;
  }
</style>